import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
import { SentryVariables } from './environments/environmentVariables';

const environment = SentryVariables.getEnv();
Sentry.init({
  sampleRate: 0.5,
  dsn: SentryVariables.getSentryDSN(),
  environment: SentryVariables.getCurrentEnvironment(),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 0.5,
});


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
